<template>
    <div class="mask" @click.stop="() => null" v-show="visible">
        <div class="board_container" :style="{ height: enableEvent ? '400px' : '230px' }">
            <div class="head"><span>标注编辑</span> <i @click.stop="visible = false" class="iconfont iconguanbi"></i></div>
            <div>
                <div class="section section_1">
                    <span class="label">内容</span>
                    <div>
                        <el-input type="textarea" :rows="2" maxlength="20" placeholder="请输入标注内容" v-model="billboardInfo.input" resize="none"></el-input>
                    </div>
                </div>
                <div class="section section_2">
                    <span class="label">事件关联</span>
                    <el-switch v-model="enableEvent"></el-switch>
                </div>
                <div class="section section_3" v-show="enableEvent">
                    <div class="row">
                        <span class="label">关联类型</span>
                        <el-select v-model="billboardInfo.data.eventType" @change="eventTypeChange" placeholder="请选择">
                            <el-option
                                v-for="item in eventTypes"
                                :key="item.value"
                                :label="item.name"
                                :value="item.value">
                            </el-option>
                        </el-select> 
                    </div>
                    <div class="row">
                        <span class="label">触发方式</span>
                        <p>鼠标左键单击</p>
                    </div>
                    <div class="row">
                        <span v-if="billboardInfo.data.eventType == 3" class="label">URL</span>
                        <span v-else class="label">选择文档</span>

                        <input v-if="billboardInfo.data.eventType == 3" :value="url" @input="changeUrl" type="text"/>
                        <button @click.stop="upload" v-if="billboardInfo.data.eventType != 3">{{ filename || '点击上传' }}</button>

                        <p v-if="billboardInfo.data.eventType == 0">(仅支持PDF格式、不超过10M)</p>
                        <p v-if="billboardInfo.data.eventType == 1">(仅支持.png/.jpg格式，不超过2M)</p>
                        <p v-if="billboardInfo.data.eventType == 2">(仅支持.mp4格式，不超过10M)</p>
                        
                    </div>
                </div>
                <div class="section srction_4">
                    <el-button @click.stop="toDelete">删除</el-button>
                    <el-button type="primary" @click.stop="confirm">确认</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import uuid from 'uuidjs'
export default {
    data(){
        return {
            visible: false,
            boardInfo: {
                enableBoard: false,
                list: [],
                pageNo: 1
            },
            enableEvent: false,
            billboardInfo: {
                id: '',
                mid: '',
                input: '',
                position: [],
                effect: true,
                data: {
                    eventType: 0,
                    content: ''
                }
            },
            eventTypes: [
                { name: '文档', value: 0 },
                { name: '图片', value: 1 },
                { name: '视频', value: 2 },
                { name: '网页', value: 3 }
            ],
            filename: '',
            url: ''
        }
    },

    computed: {
        viewer(){
            return window.viewer
        }
    },

    mounted(){

    },

    methods: {
        /**
         * 初始化
         */
        init( event ){
            this.viewer.picker.intersectModels(event, intersects => {
                intersects = intersects.filter( item => {
                    return item.object.type == 'Mesh' || item.object.type == 'Object3D'
                } )
                var object, intersect = intersects[ 0 ]
                if ( intersects.length > 0 ) {
                    object = AMRT.Utils.getModelNode( intersect.object )
                }
                if( object ){
                    if( !object.mid ){
                        return this.$message.warning('该模型不支持添加标注')
                    }
                    this.billboardInfo = {
                        id: uuid.genV4().toString(),
                        input: '',
                        position: intersect.point.toArray(),
                        mid: object.mid,
                        objectId: object.id,
                        cameraView: this.viewer.controls.getView(),
                        data: {
                            eventType: 0,
                            content: ''
                        }
                    }
                    this.filename = ''
                    this.url = ''
                    this.enableEvent = false
                    this.visible = true 
                }
            }, this, this.viewer.modelGroup.children )
        },

        /**
         * 确认编辑
         */
        confirm(){
            if( !this.billboardInfo.input ){
                this.$message.warning('标注内容不能为空!')
                return
            }
            if( this.enableEvent && !this.billboardInfo.data.content ){
                this.$message.warning('请绑定事件信息')
                return
            }
            this.toDelete()
            this.addHotSpot( this.billboardInfo )
            this.$message.success('操作成功')
            this.visible = false
        },

        addHotSpot( param ){
            const element = document.createElement('div')
            element.innerText = param.input
            element.className = param.data && param.data.content ? 'hotspot-custom-event' : 'hotspot-custom'
            element.ondblclick = () => {
                this.billboardInfo = param
                this.visible = true
            }
            const hotspot = this.viewer.hotSpotManager.add({
                objectId: param.objectId,
                position: param.position,
                cameraView: param.cameraView,
                element,
                //如果标注绑定了内容则展示内容
                onclick: param.data && param.data.content ? () => {
                    //PDF和网页
                    if( param.data.eventType == 0 || param.data.eventType == 3 ){
                        window.open( param.data.content )
                    }else{
                    //图片和视频
                        this.$mr_toast({
                            title: param.input,
                            type: param.data.eventType,
                            content: param.data.content
                        })
                    }
                } : null
            })
            param.cameraView = {
                position: param.cameraView.position.toArray(),
                target: param.cameraView.target.toArray()
            }
            hotspot.userData = param
        },

        /**
         * 上传 文件/图片/视频
         */
        upload(){
            var type
            switch ( this.billboardInfo.data.eventType ) {
                case 0:
                    type = 'file'
                    break;
                case 1:
                    type = 'image'
                    break
                case 2:
                    type = 'video'
                    break
            }
            this.$util.uploadOBS( type ).then(res => {
                this.filename = res.file.name
                this.billboardInfo.data.content = res.url
            })
        },

        /**
         * 修改事件类型
         */
        eventTypeChange(){
            this.billboardInfo.data.content = ''
            this.filename = ''
        },

        changeUrl(e){
            this.url = e.target.value
            this.billboardInfo.data.content = e.target.value
        },

        toDelete(){
            if( this.billboardInfo.id ){
                this.viewer.hotSpotManager.defaultLayer.spots.map(item => {
                    if( item.userData.id == this.billboardInfo.id ){
                        this.viewer.hotSpotManager.defaultLayer.remove(item)
                    }
                })
                this.$message.success('删除热点成功')
                this.visible = false
            }else{
                this.visible = false
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.mask{ width: 100vw; height: 100vh; position: fixed; top: 0; left: 0; z-index: 9; background-color: rgba(0, 0, 0, 0.5); }
.board_container{
    position: absolute; z-index: 9; width: 350px; height: 400px; background-color: #F2F4F6; padding: 20px; border-radius: 5px; overflow: hidden; top: 400px; right: 420px;
    .head{ 
        background-color: #fff; width: 100%; height: 34px; display: flex; justify-content: space-between; padding: 0 20px; align-items: center; margin: -20px 0 0 -20px; border-radius: 5px; font-size: 14px; color: #182C49;
        .iconfont{cursor: pointer; font-size: 14px; &:hover{transform: scale(1.2); transition: 1s transform;}}
    }
    .section{
        display: flex; padding: 15px 0;
        .label{display: inline-block; width: 20%; color: #182C49; opacity: 0.7; text-align: right; margin-right: 10px; }
        /deep/ .is-checked .el-checkbox__inner{
            background-color: #1458EA;
            border-color: #1458EA;
        }
        /deep/ .el-checkbox__input.is-checked+.el-checkbox__label{ color: #182C49; }
        /deep/ .el-textarea{
            .el-textarea__inner{border: none;}
            border: none; margin-bottom: 10px;
        }
    }
    .section_2{
        border-bottom: 1px solid #E0E2E3; display: flex; justify-content: space-between; padding: 0 0 10px 0;
        .label{opacity: 1.0;}
    }
    .section_3{
        flex-direction: column; 
        .row{ 
            display: flex; align-items: center; margin: 10px 0;
            .label{display: inline-block; width: 20%; color: #182C49; opacity: 0.7; }
            p{color: #182C49; opacity: 0.7; }
            input{ width: 240px; height: 34px; line-height: 34px; padding: 0 10px; }
        }
        .row:nth-last-child(1){
            position: relative; height: 34px;
            button{font-size: 16px; color: #1458EA; text-decoration: underline; cursor: pointer;width: 65%; overflow: hidden; text-overflow: ellipsis;}
            p{color: #182C49; opacity: 0.7; position: absolute; top: 24px; left: 80px; font-size: 12px;}
        }
    }
    .srction_4{
        justify-content: center; margin-top: 5px;
        /deep/ .el-button{
            width: 140px; height: 34px; border-radius: 17px;
            span{
                position: relative; top: -2px;
            }
        }
        /deep/ .el-button--primary{
            background-color: #1458EA; border-color: #1458EA;
        }
    }
}
.list{
    position: fixed; top: 45vh; right: 420px; width: 260px; background-color: rgba(242, 244, 246, 1); overflow-y: scroll; border-radius: 4px; z-index: 2; color: #182C49;
    &::-webkit-scrollbar {
        display: none; /* Chrome Safari */
    }
    .head{ 
        background-color: #fff;width: calc(100% - 20px); height: 34px; display: flex; align-items: center; padding: 0 10px; position: relative; font-size: 14px; position: sticky; top: 0; z-index: 1; cursor: pointer; 
        span{opacity: 0.5;}
        .iconfont{ position: absolute; right: 10px; top: 10px; transition: 1s transform; }
        .hidden{ transform: rotate(180deg); }
    }
    .body{
        background-color: rgba(242, 244, 246, 1); height: 340px; transition: height .5s; overflow: hidden;
        li{ 
            height: 34px; line-height: 34px; padding: 0 10px; display: flex; justify-content: space-between; align-items: center;  width: calc(100% - 20px); cursor: pointer;
            span:nth-child(1){
                display: block; width: 80%; text-overflow: ellipsis; overflow: hidden; white-space: nowrap; 
                .iconfont{color: #1458EA; position: relative; top: 1px; margin-right: 5px;}
            }
            .iconfont{font-size: 18px;}
            .iconfont:hover{ color: #1458EA; }
        }
        li:hover{
            background-color: rgba(20, 88, 234, .1);
        }
    }
    .empty{
        display: flex; flex-direction: column; justify-content: center; align-items: center;
        img{width: 73px; margin-bottom: 10px; opacity: 0.5;}
        p{opacity: 0.5;}
    }
}
</style>
<style>
.hotspot-custom{
    width: 150px; padding: 10px 20px; height: 36px; background-color: rgba(0,0,0,0.5); border-left: 4px solid #1458EA; color: #FFF; text-align: center; line-height: 18px; position: relative; transform: translateX(140px) translateY(28px);
}
.hotspot-custom::before{
    content: ''; display: block; width: 56px; height: 2px; background-color: #1458EA; position: absolute; left: -56px; top: 27px;
}
.hotspot-custom::after{
    content: ''; display: block; width: 10px; height: 10px; background-color: #1458EA; position: absolute; left: -56px; top: 23px;
}
.hotspot-custom-event{
    width: 150px; padding: 10px 20px; height: 36px; background-color: rgba(255,0,0,0.5); border-left: 4px solid #1458EA; color: #FFF; text-align: center; line-height: 18px; position: relative; transform: translateX(140px) translateY(28px);
}
.hotspot-custom-event::before{
    content: ''; display: block; width: 56px; height: 2px; background-color: #1458EA; position: absolute; left: -56px; top: 27px;
}
.hotspot-custom-event::after{
    content: ''; display: block; width: 10px; height: 10px; background-color: #1458EA; position: absolute; left: -56px; top: 23px;
}
</style>